<unity-page-container [contentHeader]="$contentHeader()" [contentHeaderSecondary]="$contentHeaderSecondary()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>
  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Create" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    @let parentDocument = parentDocumentResource.value();
    @if ($hasParent() === true && parentDocument) {
      <unity-textbox-readonly-control displayName="Document to Amend" [value]="parentDocument.name" />
    }
    <unity-textbox-control displayName="Name" [description]="$nameFieldDescription()" [control]="formGroup.controls.name" />
    <unity-textarea-control
      displayName="Description"
      [description]="$descriptionFieldDescription()"
      [control]="formGroup.controls.description" />
    <unity-file-uploader-control
      displayName="File Upload"
      description="Upload a file from your computer."
      [control]="formGroup.controls.upload_id"
      [allowedExtensions]="['.pdf']" />
  </unity-card-new-shared>
</unity-page-container>
